<script setup>
import { RouterView } from "vue-router";
import Layout from "./components/general/Layout.vue";
</script>

<template>
  <v-app>
    <Layout :activeUser="activeUser">
      <Suspense>
        <template #default>
          <RouterView />
        </template>
        <template #fallback>
          <div>Loading...</div>
        </template>
      </Suspense>
    </Layout>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      activeUser: null,
    };
  },
  async created() {
    await this.refreshActiveUser();
  },
  watch: {
    // everytime a route is changed refresh the activeUser
    $route: "refreshActiveUser",
  },
  methods: {
    async refreshActiveUser() {
      const isAuthenticated = await this.$auth.isAuthenticated();
      if (!isAuthenticated) {
        this.activeUser = null;
        return;
      }

      try {
        this.activeUser = await this.$auth.getUser();
      } catch (error) {
        console.error("Failed to get user:", error);
        this.activeUser = null;
      }
    },
  },
};
</script>
